import React from 'react';

export const Ai_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>AI ARTISTS</span>,
  },
];

export const DavidC_Title = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '400',
    textType: 'p',
    renderContent: () => <span>NEURAL VISUAL ARCHITECT</span>,
  },
];

export const DavidC_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => (
      <span>
        Veteran editor with 20+ years in broadcast production. Today he
        integrates generative AI into real-world pipelines with visual
        consistency and a cinematic standard. No excuses. Just results.
      </span>
    ),
  },
];

export const DavidC_Video1 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>THE LAST CASE: An AI Noir Film.</span>,
  },
];

export const DavidC_Video2 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>Choose Your Role</span>,
  },
];

export const DavidC_Video3 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>BUNNYNJA</span>,
  },
];

export const AndresB_Title = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '400',
    textType: 'p',
    renderContent: () => <span>HYBRID NARRATIVE FILMMAKER</span>,
  },
];

export const AndresB_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => (
      <span>
        Director and producer working across fiction, documentary, and AI-driven
        storytelling. Based in Barcelona, he combines classic on-set craft with
        advanced technical exploration—always in service of human stories.
        Versatile, authorial, and precise.
      </span>
    ),
  },
];

export const AndresB_Video1 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>ZOMBIE PATROL</span>,
  },
];

export const AndresB_Video2 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>TIMELINE. (A.I. Shortfilm)</span>,
  },
];

export const AndresB_Video3 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>MODE. (A.I. Shortfilm)</span>,
  },
];

export const AlvaroC_Title = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '400',
    textType: 'p',
    renderContent: () => <span>GENERATIVE WORKFLOW DESIGNER</span>,
  },
];

export const AlvaroC_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => (
      <span>
        Editor with 10+ years of experience, focused on rhythm, emotion, and
        narrative. Today he integrates generative AI into hybrid workflows to
        expand what’s possible without losing editorial control. Precision,
        detail, and collaboration.
      </span>
    ),
  },
];

export const AlvaroC_Video1 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>ATHLA</span>,
  },
];

export const AlvaroC_Video2 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>FREE</span>,
  },
];

export const AlvaroC_Video3 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>GHOST MEMORY</span>,
  },
];

export const Robot_Title = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '400',
    textType: 'p',
    renderContent: () => <span>CRAFT & INDUSTRY ORCHESTRATORS</span>,
  },
];

export const Robot_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => (
      <span>
        A director duo shaped by the set and the advertising world. Craft,
        rhythm, and staging at the core, with AI integrated as a narrative tool.
        <br />
        <br />
        Hybrid productions with strong authorship and visual solidity.
      </span>
    ),
  },
];

export const Robot_Video1 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>La nombramos Perú - VEO 3</span>,
  },
];

export const Robot_Video2 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>Adidas</span>,
  },
];

export const Robot_Video3 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>Ad Monster</span>,
  },
];

export const DavidN_Title = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '400',
    textType: 'p',
    renderContent: () => <span>SYNTHETIC NARRATIVE ENGINEER</span>,
  },
];

export const DavidN_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => (
      <span>
        Director and post-producer with 13 years in Buenos Aires and experience
        with Warner, Disney, and Viacom. Today he creates hybrid narratives
        through generative AI and interactive experiences, using technology as a
        creative engine without losing direction or storytelling.
      </span>
    ),
  },
];

export const DavidN_Video1 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>Chanel 11.12 - Concept</span>,
  },
];

export const DavidN_Video2 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>PLUTOCRACIA</span>,
  },
];

export const DavidN_Video3 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>DÍA DE MUERTOS</span>,
  },
];
